<template lang="html">
<div>

    <div class="subpage">

          <div class="bkLine clearfix">
               <div class="iName">企业logo</div>
               <div class="iContent">
                    <entUpload :files="params.corporateLogo" preKey="corporateLogo" @fileChange="fileChange" limit="1" />
               </div>
          </div>

          <div class="bkLine clearfix">
               <div class="iName">头部图</div>
               <div class="iContent">
                    <entUpload :files="params.businessRotationDiagram" preKey="businessRotationDiagram" @fileChange="fileChange" limit="6" />
               </div>
          </div>

          <div class="bkLine clearfix">
               <div class="iName">企业简介</div>
               <div class="iContent">
                 <el-input
                    style="width:45%;"
                    type="textarea"
                    :rows="5"
                    placeholder="请输入内容"
                    v-model="params.companyProfiles">
                 </el-input>
               </div>
          </div>

          <div class="bkLine adsLine clearfix">
               <div class="iName">办公地址</div>
               <div class="iContent">
                    <ads-select :adsList="preAddress" ref="adsSelect" />
               </div>
          </div>

          <div class="bkLine clearfix">
               <div class="iName">官网</div>
               <div class="iContent">
                   <el-input v-model="params.corporateWebsite" size="medium" class="elInp" placeholder="请输入内容" />
               </div>
          </div>

          <div class="bkLine clearfix">
               <div class="iName">荣誉墙</div>
               <div class="iContent">
                    <entUpload :files="params.corporateHonorWall" preKey="corporateHonorWall" @fileChange="fileChange" limit="6" />
               </div>
          </div>

          <div class="bkLine adsLine clearfix">
               <div class="iName">业务咨询</div>
               <div class="iContent">
                    <SvcAdd :preList="preSvList" ref="svcAdd" />
               </div>
          </div>

          <div class="bkLine clearfix">
               <div class="iName">工商信息显示</div>
               <div class="iContent switchLine">
                 <el-switch
                    :active-value="1"
                    :inactive-value="2"
                    v-model="params.isDisplayBusinessInformation">
                 </el-switch>
               </div>
          </div>

    </div>

</div>
</template>

<script>
import { decTextGet } from "@/api/declare/declare";
import SvcAdd from "./svcAdd";
import entUpload from "./imgUpload";
export default {
  props: ['entid'],
  components: {
    SvcAdd,
    entUpload
  },
  data() {
    return {
      params: {
        corporateLogo: '',  // 企业logo
        businessRotationDiagram: '',  // 切换图
        companyProfiles: '',  // 简介
        corporateWebsite: '', // 官网
        corporateHonorWall: '', // 荣誉墙
        isDisplayBusinessInformation: 1 // 工商信息
      },
      preAddress: [],
      preSvList: [],
      rules: {
        corporateLogo: [{
          required: true,
          trigger: 'change'
        }]
      }
    }
  },

  methods: {
    addressTrans: function (list, type) {
      var newArr = [];
      list.forEach((item, i) => {
        if (type == 1) {
          newArr.push({
            area: item.address,
            cqjQiyeEnterpriseId: this.entid,
            address: item.name,
            longitude: item.latLng.lng,
            latitude: item.latLng.lat
          })
        } else if (type == 2) {
          newArr.push({
            name: item.address,
            address: item.area,
            latLng: {
              lng: item.longitude,
              lat: item.latitude
            }
          })
        }
      });

      return newArr;
    },
    preEdit: function (e) {
      var unFormate = e.enterprise;
      for (var key in this.params) {
        if (unFormate[key]) {
          this.params[key] = unFormate[key];
        }
      };
      this.preAddress = this.addressTrans(e.enterpriseOfficeAddressList, 2);
      this.preSvList = e.enterpriseBusinessAdvisoryList;
    },
    saveReturn: function () {
      var adsList = this.addressTrans(this.$refs.adsSelect.selectedList, 1);
      var svcList = this.$refs.svcAdd.svcList || [];

      return {
        pms: this.params,
        adsList,
        svcList
      };
    },
    contentChange: function (e) {
      this.params.directoryTextContent = e;
    },
    fileChange(res) {
      console.log(res);
      this.params[res.preKey] = res.data;
    }
  },

  created: function () {

  }
}
</script>

<style lang="scss" scoped>
.subpage {
  font-size: 15px;
  .bkLine {
    position: relative;
    margin-bottom: 20px;

    .iName {
      width: 90px;
      line-height: 34px;
      float: left;
    }
    .iContent {
      margin-left: 112px;
      .elInp {
        width: 270px;
      }
    }

    .switchLine {
      line-height: 30px;
    }
  }

  .adsLine {
    padding: 45px 0;
    margin: 45px 0;
    border-top: 1px solid #f5f5f5;
    border-bottom: 1px solid #f5f5f5;
  }
}
</style>



// WEBPACK FOOTER //
// Subpage3.vue?e59e5e1c